import React, {Component, PureComponent} from "react";
import {Link} from "react-router-dom";
import EventHelper from "../../../helpers/EventHelper";
import {connect} from "react-redux";
import ACTIONS from "../../../constants/actions";
import MomentDate from "../../../components/MomentDate";
import {toggleFavorite} from "../../../redux/actions/live";

class Event extends PureComponent {
	constructor(props) {
		super(props);
		this.videoClick = this.videoClick.bind(this);
	}


	toggleFavorite(data) {
		this.props.toggleFavorite(data);
	}

	videoClick(videoId) {
		const {event} = this.props;
		//EventHelper.openVideoOnline(videoId);
		const title = EventHelper.parseTeams(event.team1, event.team2);
		const data = {
			frame : <iframe src={`https://maxline.by/event/video/${videoId}`} frameborder="0" scrolling="no" />,
			title : title
		};
		this.props.updateVideoModal(data);
	}

	render() {
		const {event, filter, results, favorites, description, league} = this.props;
		const result = EventHelper.parseResults(results);
		const team = EventHelper.parseTeams(event.team1, event.team2);
		// const descripion = EventHelper.parseDescription(event.description);
		const tv = description.getTv();
		const video_online = description.getVideoOnline();
		const tracker = description.getTracker();
		//
		// if ( filter.tv && tv === '' ) {
		// 	return '';
		// }
		//
		// if ( filter.video_online && video_online === '' ) {
		// 	return '';
		// }
		//
		// if ( filter.tracker && tracker === '' ) {
		// 	return '';
		// }

		const isFavorite = favorites.indexOf(event.id) !== -1;

		return (
			<div key={event.id} className="tr">
				<div className="td favorite">
					<span className={`stars-2 ${isFavorite && 'activated'}`} onClick={this.toggleFavorite.bind(this, event.id)}></span>
				</div>
				<div className="td time">
					<MomentDate date={event.time} isLive={true}/>
				</div>
				<div className="td players">
					<Link to={`/live/${event.id}`} title={league.name}>{team}</Link>
				</div>
				<div className="td score">
					{result.score}
				</div>
				<div className="td service">
					<div className="services-colored">
						<div className={`services-colored__tv ${tv === '' ? 'hidden' : ''}`} title={tv}></div>
						<div className={`services-colored__zone ${tracker === '' ? 'hidden' : ''}`}></div>
						<div className={`services-colored__translation ${video_online === '' ? 'hidden' : ''}`} title="Доступна видеотрансляция" onClick={() => {this.videoClick(video_online)}}></div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		favorites  : state.favorites,
		videoModal : state.videoModal
	}),
	dispatch => ({
		toggleFavorite   : (data) => {
			dispatch(toggleFavorite(data));
		},
		updateVideoModal : (data) => {
			dispatch({type : ACTIONS.VIDEO_MODAL.UPDATE, data : data})
		}
	})
)
(Event);




// WEBPACK FOOTER //
// ./src/app/pages/Main/Events/Event.js